import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByCegNavbar'
})

export class FilterByCegNavbarPipe implements PipeTransform {
    transform(jogviszonyok: any, ceg_id: any): any {
        return jogviszonyok.filter(jog_v => jog_v.ceg_id == ceg_id)
    }
}